export default function createNativeCallbackPlugin() {
  return store => {
    window.emart = window.emart || {};
    window.emart.app = window.emart.app || {};

    window.getFidoYnCallBack = function (fidoYn) {
      // alert("Native Callback( getFidoYnCallBack ) fidoYn : " + fidoYn);

      if (store.state.nativeStore.connect) {
        store.state.nativeStore.fidoYn = fidoYn;
        // store.state.nativeStore.useBioAuth = false;
      } else {
        console.log('createNativeCallbackPlugin not connect')
        return false
      }
    }

    window.useFidoYnCallBack = function (fidoYn, authYn) {
      // alert("Native Callback( useFidoYnCallBack ) fidoYn : " + fidoYn + ", authYn : " + authYn);

      if (store.state.nativeStore.connect) {
        // store.state.nativeStore.fidoYn = fidoYn;
        store.state.nativeStore.authYn = authYn;
      } else {
        console.log('createNativeCallbackPlugin not connect')
        return false
      }
    }

    /** ****************************************************** **/
    /** ************* IOS JavaScript 호출 설정 영역 ************ **/
    /** ****************************************************** **/
    window.emart.app.getFidoYn = function(fnName, fidoYn) {
      // alert("1. window.emart.app.getFidoYn");
      // alert("fnName : " + fnName);
      // alert("fidoYn : " + fidoYn);
    }

    window.emart.app.useFidoYn = function(fnName, fidoYn, authYn) {
      // alert("1. window.emart.app.useFidoYn");
      // alert("fnName : " + fnName);
      // alert("fidoYn : " + fidoYn);
      // alert("authYn : " + authYn);
    }

    /** ****************************************************** **/
    /** ******** Native Webview 상태 변화 호출 설정 영역 ********* **/
    /** ****************************************************** **/
    /** PageStatus(웹뷰 상태)
     *  Active     : 웹뷰 다시 활성화되는 시점
     *  InActive   : 웹뷰 비활성화 시점
     *  Foreground : 앱의 포그라운드 상태
     *  Background : 앱의 백그라운드 상태
    /** ****************************************************** **/
    window.windowState = function (PageStatus, url) {
      // alert("Native Callback( windowState ) PageStatus : " + PageStatus + ", url : " + url);

      if (url.includes("/myemarticon/setting") || url.includes("/home") || url.includes("/card/detail")) {
        if (PageStatus === "Active") {
          setTimeout(() => {
            // alert("device : " + store.state.nativeStore.device);

            if (store.state.nativeStore.device === 'and') {
              store.commit("nativeStore/connect", ['and']);
            } else if (store.state.nativeStore.device === 'ios') {
              store.commit("nativeStore/connect", ['ios']);
            }

            store.dispatch('nativeStore/getFidoYn');
          }, 1000);
        }
      }
    }
  }
}
